import { FormInputComponents } from '../support.type';
import { FormField } from './FormField';

export class FormFieldRating extends FormField<number> {
    override component = FormInputComponents.MrRating;

    override get data() {
        return (this.value ?? 0).toString();
    }

    override get requiredError() {
        return 'لطفاً بازخورد خود را ثبت کنید.';
    }
}
